import { MDSModal } from "@/mds";
import { WizardContainer } from "@/components/onboarding/components/welcome-wizard";
import { ImportNotes } from "@/components/importing/import-notes";
import styled from "@emotion/styled";

interface ImportWizardProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ImportWizard = ({ isOpen, onClose }: ImportWizardProps) => {
  return (
    <MDSModal isOpen={isOpen} handleClose={onClose}>
      <ModalContent>
        <WizardContainer data-component="wizard-container">
          <ImportNotes placement="profile-menu" onClose={onClose} />
        </WizardContainer>
      </ModalContent>
    </MDSModal>
  );
};

const ModalContent = styled.div`
  overflow: visible;
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
`;
